import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ProjectManagerOption } from '@ps/survey-utils';
import { SurveyManagementActions } from './survey-management.actions';

@Injectable({ providedIn: 'root' })
export class SurveyManagementActionsFacade {
  private readonly _store = inject(Store);

  public assignBuyerProjectManager(
    surveyId: number,
    projectManager: ProjectManagerOption,
  ): void {
    this._store.dispatch(
      SurveyManagementActions.assignBuyerProjectManager({
        surveyId,
        projectManager,
      }),
    );
  }

  public removeBuyerProjectManager(surveyId: number): void {
    this._store.dispatch(
      SurveyManagementActions.removeBuyerProjectManager({ surveyId }),
    );
  }

  public assignOperatorProjectManager(
    surveyId: number,
    projectManager: ProjectManagerOption,
  ): void {
    this._store.dispatch(
      SurveyManagementActions.assignOperatorProjectManager({
        surveyId,
        projectManager,
      }),
    );
  }

  public removeOperatorProjectManager(surveyId: number): void {
    this._store.dispatch(
      SurveyManagementActions.removeOperatorProjectManager({ surveyId }),
    );
  }

  public createPriceBlock(surveyId: number): void {
    this._store.dispatch(
      SurveyManagementActions.createPriceBlock({ surveyId }),
    );
  }

  public resetFusionBlockStats(surveyId: number): void {
    this._store.dispatch(
      SurveyManagementActions.resetFusionBlockStats({ surveyId }),
    );
  }

  public loadFusionStats(surveyId: number): void {
    this._store.dispatch(SurveyManagementActions.loadFusionStats({ surveyId }));
  }

  public resetFusionStatsPanel(): void {
    this._store.dispatch(SurveyManagementActions.resetFusionStatsPanel());
  }
}
